export default "__VITE_ASSET__BWUA8nFb__"